var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultActiveColor, defaultColor } from '../utils';
const FullScreen = (_a) => {
    var { size = 24, color: colorInit = defaultColor, isExpand, useCurrentColor, isActive, activeColor = defaultActiveColor } = _a, rest = __rest(_a, ["size", "color", "isExpand", "useCurrentColor", "isActive", "activeColor"]);
    const color = useCurrentColor
        ? 'currentColor'
        : isActive
            ? activeColor
            : colorInit;
    const props = Object.assign({ width: size, height: size }, rest);
    return isExpand ? (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none" }, props),
        React.createElement("path", { d: "M15.1801 4C14.6212 4 14.3418 4.67561 14.7373 5.07108L16.0864 6.42229L6.42229 16.0864L5.07108 14.7373C4.67561 14.3418 4 14.6212 4 15.1801V19.3718C4 19.7187 4.28026 20 4.62617 20H8.81987C9.37881 20 9.6582 19.3244 9.26272 18.9289L7.91357 17.5777L17.5777 7.91357L18.9289 9.26272C19.3244 9.6582 20 9.37881 20 8.81987V4.62617C20 4.28026 19.7187 4 19.3718 4H15.1801Z", fill: color }))) : (React.createElement("svg", Object.assign({ width: size, height: size, viewBox: "0 0 14 14", fill: color }, rest),
        React.createElement("path", { d: "M9.64991 0.333008C9.18412 0.333008 8.9513 0.896013 9.28086 1.22558L10.4052 2.35159L2.35171 10.405L1.2257 9.28074C0.896135 8.95118 0.33313 9.184 0.33313 9.64979V13.1428C0.33313 13.432 0.566681 13.6663 0.854939 13.6663H4.34969C4.81547 13.6663 5.04829 13.1033 4.71873 12.7738L3.59444 11.6478L11.6479 3.59432L12.7739 4.71861C13.1035 5.04817 13.6665 4.81535 13.6665 4.34957V0.854817C13.6665 0.566559 13.4321 0.333008 13.1429 0.333008H9.64991Z" })));
};
export default FullScreen;
